var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJepq(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_2",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #a06e00;\n      }\n\n      .cls-3 {\n        fill: #e0b12b;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-5 {\n        fill: #f9d953;\n      }\n\n      .cls-6 {\n        fill: #0a95c6;\n      }\n\n      .cls-7 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_\\u9577\\u65B9\\u5F62_",
    "data-name": "&lt;\\u9577\\u65B9\\u5F62&gt;",
    className: "cls-1",
    width: 28,
    height: 28
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_28_\\u30CA\\u30B9\\u30C0\\u30C3\\u30AF\\u30AB\\u30D0\\u30B3\\u6BCE\\u6708\\u5206\\u914D",
    "data-name": "28_\\u30CA\\u30B9\\u30C0\\u30C3\\u30AF\\u30AB\\u30D0\\u30B3\\u6BCE\\u6708\\u5206\\u914D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_28_\\u30CA\\u30B9\\u30C0\\u30C3\\u30AF\\u30AB\\u30D0\\u30B3\\u6BCE\\u6708\\u5206\\u914D_2xPNG_",
    "data-name": "28_\\u30CA\\u30B9\\u30C0\\u30C3\\u30AF\\u30AB\\u30D0\\u30B3\\u6BCE\\u6708\\u5206\\u914D\\uFF082xPNG\\uFF09"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u30CA\\u30B9\\u30C0\\u30C3\\u30AF",
    "data-name": "\\u30CA\\u30B9\\u30C0\\u30C3\\u30AF"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_",
    "data-name": "\\u25CF",
    className: "cls-4",
    d: "M23.1,13.3c0,5.412-4.386,9.8-9.8,9.8-.657,0-1.303-.065-1.924-.189-4.491-.894-7.876-4.857-7.876-9.611C3.5,7.886,7.888,3.5,13.3,3.5s9.535,4.126,9.788,9.312c.007.16.012.325.012.488Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_\\u30CA\\u30B9\\u30C0\\u30C3\\u30AF-2",
    "data-name": "\\u30CA\\u30B9\\u30C0\\u30C3\\u30AF"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M6.758,18.862s2.679-7.211,2.782-7.622c.103-.411.411-.722.411-.722h3.091s-.308.308-.411.722-2.782,7.622-2.782,7.622h-3.091Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M19.842,7.738s-2.679,7.211-2.782,7.623c-.103.411-.411.722-.411.722h-3.091s.308-.308.411-.722c.103-.414,2.782-7.623,2.782-7.623h3.091Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M13.042,15.979c-.206,0-.308-.103-.411-.308-.103-.206-.619-1.649-.619-1.752s-.065-.179,0-.308c.103-.206,1.03-2.885,1.339-2.885l.263-.103c.103,0,.308.103.411.308.103.206.562,1.441.562,1.544s.103.411,0,.619c-.065.131-.825,2.885-1.544,2.885Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_\\u30C9\\u30EB\\u888B",
    "data-name": "\\u30C9\\u30EB\\u888B"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M24.5,20.54c0,2.187-2.068,3.96-4.62,3.96-.935,0-1.806-.238-2.534-.648-1.257-.708-2.086-1.927-2.086-3.312,0-2.187,4.62-5.998,4.62-5.998,0,0,.738.609,1.625,1.48,1.331,1.308,2.995,3.206,2.995,4.519Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.5,20.54c0,2.187-2.068,3.96-4.62,3.96-.935,0-1.553-.106-2.28-.516.321.171.976.205,1.763.186,1.783-.041,3.534-1.682,3.492-3.733-.03-1.47-.899-3.009-1.711-4.298-.108-.019-.115-.058-.122-.097.161-.017.322-.023.483-.021,1.331,1.308,2.995,3.206,2.995,4.519Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M18.134,15.917l-1.692-2.169s.326-.127.761-.069c.431.057.338.224.745.253.384.027.455-.431.902-.431s.666.431,1.051.431.497-.402.943-.431c.414-.027.503.505,1.01.472.257-.017.415-.256.695-.34.495-.149.818.032.794.033l-1.659,2.262-3.55-.012Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M21.688,15.933l1.655-2.266c.033-.015-.372-.158-.741-.046l-1.494,2.312h.579Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 17.774,
    y: 15.791,
    width: 4.212,
    height: 0.544,
    rx: 0.22,
    ry: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.802,22.67c-.397,0-.742-.061-1.036-.183-.294-.122-.523-.303-.687-.543s-.251-.535-.259-.886h.988c.013.167.063.306.15.418.086.112.202.196.346.251.144.056.307.083.489.083s.34-.026.474-.078c.134-.052.239-.126.314-.222.075-.095.113-.206.113-.333,0-.113-.034-.208-.101-.285-.068-.077-.165-.143-.291-.198-.126-.055-.28-.104-.462-.147l-.545-.137c-.419-.102-.747-.263-.984-.481-.237-.219-.356-.508-.356-.867,0-.3.08-.562.241-.786.161-.224.381-.398.662-.523.28-.124.6-.186.959-.186.366,0,.685.063.958.188.273.125.486.3.639.523.153.223.232.48.236.771h-.981c-.018-.2-.102-.354-.254-.463-.152-.109-.354-.163-.607-.163-.171,0-.317.024-.439.073-.122.049-.215.117-.278.203s-.095.185-.095.296c0,.122.037.224.11.305.073.081.171.147.293.196.122.05.252.092.389.125l.449.11c.208.047.402.11.582.19.18.08.337.178.472.295.135.117.24.255.314.415.074.16.111.344.111.553,0,.3-.075.561-.226.784-.151.223-.369.396-.655.518-.286.122-.63.183-1.031.183ZM19.599,23.266v-6.301h.399v6.301h-.399Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJepq);
export default __webpack_public_path__ + "static/media/JEPQ.e99459a4008bfd97005a55f70e5dd616.svg";
export { ForwardRef as ReactComponent };